<template>
    <div>
            <div class="flex bottom8">

                <el-select style="width: 90px" class="marr4" v-model="i_state" size="mini" >
                    <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select  style="width: 100px"  class="marr4" v-model="i_bzid" size="mini"  :placeholder="$t('creditManagement_please_select_currency')">
                    <el-option
                            v-for="item in bzList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>

                <el-input style="width: 120px" class="marr4" clearable size="mini" :placeholder="$t('creditManagement_search_by_customer_name')" v-model="vc_khname">
                </el-input>
                <el-button class="mrl20" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="addnew({},'add')">{{$t('creditManagement_add_new')}}</el-button>
                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="zuoFei">{{$t('button_nullify')}}</el-button>
                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="tongji">{{$t('creditManagement_export')}}</el-button>
            </div>
        <el-table
                class="mrt10"
                ref="table"
                size="mini" :stripe="true"
                :height="tableHeight"
                border  @selection-change="handleSelectionChange"
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%;margin-right: 9px;margin-left: 9px">
            <el-table-column align="center" type="selection" width="50px" ></el-table-column>
            <el-table-column  :label="$t('form_serial_number')" align="center" type="index" width="45px"></el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_customer_name')" prop="vc_khname"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_enterprise_code')" prop="vc_khcode"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_currency')" prop="vc_bzname" width="60px" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_total_credit_limit')" prop="f_sxed" show-overflow-tooltip>
                <template slot-scope="scope"><div style="text-align: right">{{scope.row.f_sxed}}</div></template>
            </el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_credit_term_days')" width="75px" prop="i_sxts"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_type')" width="50px" prop="i_flag"    show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.i_flag?$t('creditManagement_fixed'):$t('creditManagement_temporary')}}</template>

            </el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_insured_portion')" prop="f_insure"    show-overflow-tooltip>
                <template slot-scope="scope"><div style="text-align: right">{{scope.row.f_insure}}</div></template>
            </el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_available_credit_limit')" prop="f_kyed"    show-overflow-tooltip>
                <template slot-scope="scope"><div style="text-align: right">{{scope.row.f_kyed}}</div></template>
            </el-table-column>
            <el-table-column align="center" :label="$t('creditManagement_expiry_date')" prop="dt_expiredate"   width="85px"   show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_notes')" prop="vc_note"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_enter_time')" prop="dt_createtime"  width="85px"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_input_person')" width="80px" prop="vc_lruname"   show-overflow-tooltip></el-table-column>
           <el-table-column align="center" :label="$t('form_operate')" show-overflow-tooltip width="120px">
                <template slot-scope="scope">
                    <el-button  size="mini" type="text" @click="addnew(scope.row,'detail')">{{$t('creditManagement_view')}}</el-button>
                    <el-button  size="mini" type="text" @click="addnew(scope.row,'copy')">{{$t('creditManagement_copy_and_create_new')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        @size-change="sizeChange"
                        :page-sizes="pageSizes"
                        layout="total,sizes,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="680px"
                    top="30"
                    height="300"
                    :title="detailTitle"
                    :visible.sync="detailDialog"
                    v-if="detailDialog"
                    :close-on-click-modal="false" @close="detailClose">
                <detail-page :data="detailData" @close="detailClose"></detail-page>
            </el-dialog>
        </div>
        <reportdialog  ref="mydialog"  ></reportdialog>
        <eDialog ref="eDialog" :activePage="activePage"></eDialog>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import DetailPage from "./DetailPage"
    import {baseerp} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog";
    import EnterTemplate from "../archiveManage/enterTemplate/EnterTemplate"; // dialog

    export default {
        name: "index",
        components: {
            EnterTemplate,
            eDialog,DetailPage,
            reportdialog,
        },
        data() {
            return {
                loading:true,
                activePage:"report/res/spread.vue",
                mid:0,
                tableHeight:0,
                baseerp:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                pageSizes:[100],
                total:0,
                detailData:{},
                detailDialog:false,
                detailTitle:this.$t('creditManagement_add_new'),
                i_gsid:0,
                bzList:[],
                multipleSelection:[],
                i_bzid:1,
                vc_khname:'',
                i_state:1,
                stateList:[{i_id:1,vc_name:this.$t('creditManagement_valid')},{i_id:-1,vc_name:this.$t('creditManagement_expired')}],
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getCreditAuthorizeList()
            this.getbzlist();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-150

            },
            handleSelectionChange(val) {
                let v=val;
                this.multipleSelection = v.map(m=>m.i_id);
            },
            addnew(data={},type='add'){

                if (type=='add'){
                    this.detailData={
                        i_id:0,
                        vc_khcode:'',
                        vc_khname:'',
                        i_khid:'',
                        f_sxed:0,
                        i_sxts:0,
                        i_flag:1,
                        f_insure:0,
                        f_kyed:0,
                        dt_expiredate:0,
                        dt_createtime:0,
                        vc_lruname:0,
                        i_bzid:1,
                        vc_bzname:this.$t('creditManagement_rmb'),
                        vc_note:'',
                    }
                }else if(type=='copy'){
                    this.detailData=data;
                    this.detailData.i_id=0;

                }else{
                    this.detailData=data;
                    this.detailTitle=this.$t('creditManagement_view')
                }
                this.detailDialog=true;
            },
            test(a){
                console.log(a);
            },
            tongji(){
                let loading =this.$loading({lock:true,text:this.$t('creditManagement_loading_data_please_wait')+"...",background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({
                    title:this.$t('creditManagement_export'),
                    btn:{f:this.test,l:{a:{title:this.$t('creditManagement_submit'),name:'a1'}}},
                    parm:{
                        type:'CreditRpt',
                        mid:this.$route.meta.mid,
                        arg:{
                            i_bzid:this.i_bzid,
                            i_state:this.i_state,
                            vc_khname:this.vc_khname,
                        }},
                    w:1024,h:768});



                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })
            },
            detailClose(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getCreditAuthorizeList()
                }
                this.detailDialog=false;

            },
            gosearch(){
                this.currentPage=1
                this.getCreditAuthorizeList()
            },
            async getCreditAuthorizeList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid:this.mid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    i_state: this.i_state,
                    vc_khname:this.vc_khname,
                    i_khid:this.i_khid,
                    i_bzid:this.i_bzid
                };
                let res=await API.getCreditAuthorizeList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.seList;
                    this.total=res.data.total;
                    this.pageSizes=this.getPageSizes(this.total);

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            getPageSizes(total){
                const max=Math.floor((total+100)/100);
                return  Array.from({length:max},(_, i)=> 100 * (i+1));
            },
            zuoFei(){
                if(this.multipleSelection.length>0){
                    //this.$confirm('是否继续作废这'+this.multipleSelection.length+'项数据',this.$t('creditManagement_prompt'),{

                    this.$confirm(this.$t('creditManagement_do_you_want_to_invalidate_these_records',{num:this.multipleSelection.length}),this.$t('creditManagement_prompt'),{
                        confirmButtonText:this.$t('creditManagement_continue'),
                        cancelButtonText:this.$t('creditManagement_cancel'),
                        type:'warning'
                    }).then(async()=>{
                        this.invalidateCredit()
                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:this.$t('creditManagement_cancelled')
                        })
                    })
                }else{
                    this.$message.warning(this.$t('creditManagement_please_check_the_data_to_be_invalidated'))
                }

            },
            async invalidateCredit(){
                let param={
                    i_ids:this.multipleSelection
                };
                let res=await API.invalidateCredit(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.currentPage=1;
                    this.getCreditAuthorizeList()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getCreditAuthorizeList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getCreditAuthorizeList();
            },
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        align-items: center;
        flex-wrap:wrap ;

    }
    .bottom8{
        margin: 8px;
    }
    .el-radio{
        margin-right: 10px;
    }
</style>